<template>
  <div>
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
          <!-- General searchfield -->
          <div class="q-ml-md" style="flex-grow: 1">
            <q-input color="grey-5" v-model="searchTerm" @input="applyFilters" :placeholder="getString(null, 'Search by code or subject', 'Zoek op code of onderwerp')
              " />
          </div>
        </div>
      </div>
      <!-- Add button -->
      <div class="col-6" style="justify-content: flex-end">
        <q-btn v-if="$store.state.meStore.me.rights.includes(
          `${permission}.add`
        )
          " class="capitalize ctrl-button right" color="ctrl-turquoise" :label="getString('action.add')"
          @click="$router.push(`/${module}/add`)" icon-right="add" />
        <q-btn v-if="$store.state.meStore.me.rights.includes(
          `${permission}.delete`
        )
          " class="capitalize ctrl-button bg-ctrl-grey right q-mr-md" color="ctrl-turquoise"
          :disabled="!rowSelection.length" :label="$store.state.stringsStore.strings.list.actions.label
            " :class="{ 'button-active': rowSelection.length }">
          <q-icon size="large" name="mdi-chevron-down" />
          <i v-show="rowSelection.length" class="counter">{{
            rowSelection.length
          }}</i>
          <!-- Direct child of target -->
          <q-popover anchor="bottom middle" self="top middle">
            <q-list link>
              <q-item :class="{ disabled: !rowSelection.length }" class="toolbar-list-item"
                @click.native="removeRows('emails')">
                <q-icon color="positive" size="large" name="delete" />
                {{
                  $store.state.stringsStore.strings.action
                    .remove
                }}
              </q-item>
            </q-list>
          </q-popover>
        </q-btn>
      </div>
    </div>

    <!-- Data table -->
    <table-overview :endpoint="endpoint" :responseFormat="module" :columns="columns" :join="categories"
      :permission="permission" :module="module" :useStoreFilters="false" :selectable="selectable">
    </table-overview>
  </div>
</template>

<script>
import TableOverview from '@/components/overview/TableOverview.vue';
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';

export default {
  mixins: [
    filtersMixin,
  ],
  components: {
    TableOverview,
  },
  data() {
    return {
      loaded: false,
      module: 'emails',
      endpoint: 'emails',
      permission: 'emails',
      selectable: true,
      isLoading: false,
      searchTerm: '',
      columns: [
        {
          name: 'code',
          title: this.$store.state.stringsStore.language === 'en' ? 'Type' : 'Soort',
          sortField: 'code',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
          callback: code => this.getString(`module.emails.code.${code}`),
        },
        {
          name: 'subject',
          title: this.$store.state.stringsStore.language === 'en' ? 'Subject' : 'Onderwerp',
          sortField: 'subject',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
      ],
      preferences: {
        page: 1,
        perPage: 10,
        sortField: null,
        sortOrder: null,
      },
    };
  },
  methods: {
    getString,
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
</style>
